<div class="flex-grow-1">
  <div class="input-group">
    <input
      class="form-control"
      #picker="ngbDatepicker"
      [class.is-invalid]="dateInvalid()"
      [disabled]="disabled"
      [id]="id() ?? name()"
      [markDisabled]="markDisabled"
      [maxDate]="maximumDate()"
      [minDate]="minimumDate()"
      [name]="name()"
      [ngClass]="ngClass()"
      [ngModel]="internalNgbDate()"
      [placeholder]="placeholder() | translate"
      [restoreFocus]="null"
      [startDate]="startDate()"
      (dateSelect)="onDateSelection($event)"
      (focus)="picker.toggle()"
      autocomplete="off"
      container="body"
      ngbDatepicker
      placement="auto"
    />

    @if (clearable() && internalDate() != null && disabled === false) {
      <portal-icon-button
        class="date-picker__clear"
        (onClick)="onClear()"
        iconClass="far fa-times fa-fw"
      ></portal-icon-button>
    }

    <button
      class="btn"
      [disabled]="disabled"
      [ngClass]="{ 'btn-outline-secondary': dateInvalid() === false, 'btn-outline-danger': dateInvalid() }"
      (click)="picker.toggle()"
      type="button"
    >
      <i class="far fa-calendar fa-sm"></i>
    </button>
  </div>

  @if (showValidationErrors()) {
    <portal-validation-errors
      class="invalid-feedback"
      [errors]="control.errors ?? {}"
      [ignoreErrors]="['invalidTime']"
    >
      <ng-template portalValidationError="time">
        {{ 'common.datePicker.invalidTime' | translate }}
      </ng-template>
    </portal-validation-errors>
  }
</div>

@if (withTime()) {
  <div>
    <input
      class="form-control"
      #timeInput="ngModel"
      [class.is-invalid]="timeInput.invalid || (timeRequired() && invalid())"
      [disabled]="disabled"
      [ngModel]="timeUi()"
      [placeholder]="defaultTime() ?? ('common.datePicker.time' | translate)"
      [required]="timeInputRequired()"
      (input)="onTimeInput(timeInput.value)"
      portalValidTime
      type="text"
    />
    <portal-validation-errors class="invalid-feedback" [errors]="timeInput.errors">
      <ng-template portalValidationError="time">{{
        'common.datePicker.invalidTime' | translate
      }}</ng-template>
    </portal-validation-errors>
  </div>
}
